<template>
    <div
        :key="vpsPlan.name"
        class="product__item-grid-tile product__item-grid-tile-hosting"
        :class="{ 'is-selected': orderVpsState({ name: vpsPlan.name, domain: domain.domain }) }"
    >
        <div v-if="vpsPlan.marketing" class="product__item__grid-tile-highlight">
            {{ vpsPlan.marketing }}
        </div>
        <div class="product__item-grid-tile-header">
            <div class="u-flex-between">
                <h3 class="gamma | product__item-grid-tile-title">{{ vpsPlan.name }}</h3>
                <span>
                    <price-display :price="monthPrice" />
                    {{ trans('order.per-month') }}
                </span>
            </div>
            <p class="product__item-grid-tile-subtitle p--flush">
                {{ vpsPlan.description }}
            </p>
        </div>

        <div class="product__item-grid-tile-list | clearfix">
            <product-descriptors v-if="vpsPlan.descriptors" :descriptors="vpsPlan.descriptors.main" />
        </div>

        <div class="product__item-grid-tile-list | u-margin-bottom clearfix">
            <product-descriptors
                v-if="vpsPlan.descriptors"
                :descriptors="vpsPlan.descriptors.small"
                :small="true"
            />
        </div>

        <div class="product__item-grid-tile-button">
            <div class="u-text-center">
                <button
                    :class="{
                        'btn--ghost': !orderVpsState({ name: vpsPlan.name, domain: domain.domain }),
                        'btn--ghost-selected': orderVpsState({ name: vpsPlan.name, domain: domain.domain })
                    }"
                    @click="
                        switchVps({
                            name: vpsPlan.name,
                            domain: domain.domain,
                            status: displayPriceType,
                            price: productPrice,
                            gross_price: grossProductPrice,
                            period: defaultPeriod
                        }),
                        passName(vpsPlan.name)
                    "
                    type="button"
                    dusk="upgrade-vps-button"
                    class="btn | u-full-width"
                >
                    <span v-if="!orderVpsState({ name: vpsPlan.name, domain: domain.domain })">{{
                            trans('order.select')
                        }}</span>
                    <span v-else>{{ trans('order.chosen') }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PriceDisplay from '@/components/Price/PriceDisplay.vue';
import ProductDescriptors from '../../../register/src/components/ProductDescriptors.vue';
import productMixin from '../../../register/src/mixins/product.js';

export default {
    components: {
        ProductDescriptors,
        PriceDisplay
    },
    mixins: [productMixin],
    props: {
        vpsPlan: {
            type: Object,
            required: true,
            default: () => {}
        },
        domain: {
            type: String
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            productType: 'vps'
        };
    },
    computed: {
        ...mapGetters({
            orderVpsState: 'order/vpsState'
        })
    },
    methods: {
        ...mapActions({
            switchVps: 'order/switchVps'
        }),
        passName (name) {
            this.$parent.changeVpsPlan(name);
        }
    }
};
</script>
